<template>
  <section>
    <div v-if="loading">

      <!-- Filter -->
      <div class="intro-y flex flex-col-reverse sm:flex-row items-center">
        <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0">
          <h2 class="intro-y text-lg font-medium mr-auto mt-8">
            Perfiles ({{ profiles.length }})
          </h2>
        </div>
        <div class="w-full sm:w-auto flex">
            <a data-target="#profile" data-toggle="modal" class="button text-white bg-theme-1 shadow-md mr-2">Crear Perfil</a>
        </div>
      </div>
      <!-- END: Filter -->

      <!-- Edit -->
      <div class="intro-y box mt-6" v-if="boxedit">
        <div class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200">
          <h2 class="font-medium text-base mr-auto">
              Editar Perfil
          </h2>
        </div>
        <form  @submit.prevent="updateProfile">
        <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
          <div class="col-span-6 sm:col-span-6">
              <label>Nombre:</label>
              <input v-on:input="updateValue('name',$event)" type="text" class="input w-full border mt-2 flex-1"
                :value="profile.name" required>
          </div>
          <div class="mt-3 col-span-6 sm:col-span-6 xxl:col-span-6">
              <label>Equipo</label>
              <select class="input w-full border mt-2" v-on:input="updateValue('team_id',$event)"
                  :value="profile.team_id" required>
                  <option disabled>Seleccione el equipo</option>
                  <option v-for="team in teams" v-bind:value="team.id">
                    {{team.name}}
                  </option>
              </select>
          </div>
          <div class="col-span-6 sm:col-span-6">
              <label>Estado</label>
              <select class="input w-full border mt-2" v-on:input="updateValue('status',$event)"
                  :value="profile.status" required>
                  <option disabled>Seleccione el usuario</option>
                  <option value="0">Inactivo</option>
                  <option value="1">Activo</option>
              </select>
          </div>
        </div>
        <div class="px-5 py-3 text-right border-t border-gray-200">
            <button type="button" v-on:click="closeEditProfile()" class="button w-20 border text-gray-700 mr-1">Cancelar</button>
            <button type="submit" class="button w-20 bg-theme-1 text-white" id="create">Modificar</button>
        </div>
        </form>
      </div>
      <!-- END: Edit -->

      <!-- List -->
      <div class="intro-y grid grid-cols-12 gap-3 sm:gap-6 mt-5">
        <div class="col-span-12 sm:col-span-4 xxl:col-span-3 box p-5 cursor-pointer zoom-in"
            v-bind:class="{'bg-theme-1': index % 2 !== 0}"
            v-for="(profile, index) in profiles">
            <div class="font-medium text-base" v-bind:class="{'text-white': index % 2 !== 0}">
              {{profile.name}}
            </div>
            <div v-bind:class="{'text-gray-600' : index % 2 === 0 , 'text-theme-25' : index % 2 !== 0}">
              {{profile.team.name}} - {{profile.status === 0 ? 'Inactivo' : 'Activo'}}
            </div>
            <div class="absolute top-0 right-0 mr-2 mt-2 dropdown ml-auto">
                <a class="dropdown-toggle w-5 h-5 block" href="javascript:;">
                  <app-icon v-bind:name="'more-vertical'" v-bind:classname="'w-5 h-5 text-gray-500'"></app-icon>
                </a>
                <div class="dropdown-box mt-5 absolute w-40 top-0 right-0 z-10">
                    <div class="dropdown-box__content box p-2">
                        <a v-on:click="editProfile(profile)" class="flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md">
                          <app-icon v-bind:name="'edit'" v-bind:classname="'w-4 h-4 mr-2'"></app-icon> Editar
                        </a>
                        <a v-on:click="removeProfile(profile)" class="flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md">
                          <app-icon v-bind:name="'trash'" v-bind:classname="'w-4 h-4 mr-2'"></app-icon> Eliminar
                        </a>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <!-- END: List -->

    </div>

    <div v-else>
      <app-loading></app-loading>
    </div>

    <!-- Modal -->
    <div class="modal" id="profile">
        <div class="modal__content modal__content--sm">
          <div class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200">
            <h2 class="font-medium text-base mr-auto">
                Crear Perfil
            </h2>
          </div>
          <form  @submit.prevent="createProfile">
          <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
            <div class="col-span-12 sm:col-span-12">
                <label>Nombre:</label>
                <input  type="text" class="input w-full border mt-2 flex-1" v-model="profile.name" required>
            </div>
            <div class="col-span-12 sm:col-span-12">
                <label>Equipo</label>
                <select class="input w-full border mt-2 flex-1" v-model="profile.team_id" required>
                    <option disabled>Seleccione el equipo</option>
                    <option v-for="team in teams" v-bind:value="team.id">
                      {{team.name}}
                    </option>
                </select>
            </div>
          </div>
          <div class="px-5 py-3 text-right border-t border-gray-200">
              <button type="button" data-dismiss="modal" class="button w-20 border text-gray-700 mr-1">Cancelar</button>
              <button type="submit" class="button w-20 bg-theme-1 text-white" id="create">Crear</button>
          </div>
          </form>
        </div>
    </div>
    <!-- Modal End -->

  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Icon from '@/components/admin/partials/Icon'
import Loading from '@/components/admin/partials/LoadingWhite'

export default {
  name: 'AdminListProfile',
  data () {
    return {
      loading: false,
      boxedit: false,
      profile: {
        name: '',
        status: '',
        team_id: '',
        entity: 'profile'
      },
      profile_current: {}
    }
  },
  computed: {
    ...mapGetters({
      profiles: 'getProfiles',
      teams: 'getTeams'
    })
  },
  beforeMount () {
    //SEND ENTITY AND MUTATION
    this.getAll('profile')
    .then(() => {
      this.loading = true
    }),
    this.getAll('team')
    .then(() => {
      this.loading = true
    })
  },
  methods: {
    createProfile () {
      var vm = this
      window.$('#create').button('loading')
      vm.store(vm.profile).then(item => {
        window.$('#profile').modal('hide')
        vm.profile = { name: '', entity: 'profile', team_id: '' }
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/profiles')
      })
      .catch(error => {
        window.$('#create').button('reset')
        vm.profile = { name: '', entity: 'profile', team_id: '' }
      })
    },
    removeProfile: function (value) {
      var vm = this
      vm.form = {
        id : value.id,
        entity : 'profile'
      }
      vm.loading = false
      vm.remove(vm.form).then(item => {
        vm.loading = true
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/profiles')
      })
      .catch(message => {
        vm.loading = true
      })
    },
    editProfile: function (value) {
      this.boxedit = true
      this.profile = value
    },
    closeEditProfile: function () {
      this.boxedit = false
      this.profile_current = {}
    },
    updateProfile: function (value) {
      var vm = this
      vm.form = {
        id : vm.profile.id,
        entity : 'profile',
        team_id: vm.profile_current.team_id,
        name: vm.profile_current.name,
        status: vm.profile_current.status
      }
      vm.loading = false
      vm.update(vm.form).then(item => {
        vm.loading = true
        vm.boxedit = false
        vm.profile = { name: '', entity: 'profile' }
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/profiles')
      })
      .catch(message => {
        vm.loading = true
      })
    },
    updateValue (attribute, e) {
      this.profile_current[attribute] = e.target.value
    },
    ...mapActions([
      'getAll',
      'remove',
      'store',
      'update'
    ])
  },
  components: {
    appIcon: Icon,
    appLoading: Loading
  }
}
</script>



// WEBPACK FOOTER //
// ListProfile.vue?1f8eb125